import { useState } from 'react';
import { useAuth } from '../lib/auth';
import { CupIcon } from '../components/CupIcon';

/** Tela bloqueante do 1º acesso: usuário com senha provisória define uma nova. */
export function ChangePassword() {
  const { email, changePassword, signOut } = useAuth();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (pw.length < 6) {
      setErr('A nova senha deve ter ao menos 6 caracteres.');
      return;
    }
    if (pw !== pw2) {
      setErr('As senhas não coincidem.');
      return;
    }
    setBusy(true);
    const { error } = await changePassword(pw);
    setBusy(false);
    if (error) setErr(error);
  }

  return (
    <div className="login-wrap">
      <form className="card card-pad login-card" onSubmit={submit}>
        <div className="mark" style={{ margin: '0 auto 8px' }}><CupIcon size={22} /></div>
        <h1>Defina sua senha</h1>
        <p className="sub">
          Primeiro acesso de {email}. Crie uma senha pessoal para continuar.
        </p>

        <div className="field">
          <label>Nova senha</label>
          <input
            type="password"
            required
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            autoComplete="new-password"
            placeholder="Ao menos 6 caracteres"
          />
        </div>

        <div className="field">
          <label>Confirmar nova senha</label>
          <input
            type="password"
            required
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            autoComplete="new-password"
          />
        </div>

        <button className="btn-primary" style={{ width: '100%', marginTop: 6 }} disabled={busy}>
          {busy ? 'Salvando…' : 'Salvar e entrar'}
        </button>

        {err && <p className="err">{err}</p>}

        <button
          type="button"
          className="btn-ghost btn-sm"
          style={{ width: '100%', marginTop: 10 }}
          onClick={() => signOut()}
        >
          Sair
        </button>
      </form>
    </div>
  );
}
